import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, styled, TextField, Typography } from "@mui/material";

export const ProjectDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: '#1e1e2d',
    color: '#ffffff',
    borderRadius: '8px',
    maxWidth: '500px',
    width: '100%'
  }
}));

export const ProjectDialogTitle = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: 'rgba(33, 33, 50, 0.7)',
  padding: '16px 24px',
  fontSize: '1.2rem',
  fontWeight: 600,
  position: 'relative'
}));

export const ProjectDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px'
}));

export const ProjectDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: '16px 24px',
  borderTop: '1px solid rgba(255, 255, 255, 0.1)'
}));

export const ProjectTitleField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isError'
})<{ isError?: boolean }>(({ theme, isError }) => ({
  '& .MuiOutlinedInput-root': {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    '& fieldset': {
      borderColor: isError ? '#f44336' : 'rgba(255, 255, 255, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: isError ? '#f44336' : 'rgba(255, 255, 255, 0.2)',
    },
    '&.Mui-focused fieldset': {
      borderColor: isError ? '#f44336' : '#2196f3',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
}));

export const ProjectDescriptionField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.2)',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#2196f3',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'rgba(255, 255, 255, 0.7)',
  },
}));

export const CreateButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isValid'
})<{ isValid?: boolean }>(({ theme, isValid }) => ({
  backgroundColor: isValid ? '#2196f3' : 'rgba(33, 150, 243, 0.3)',
  color: 'white',
  padding: '10px 24px',
  borderRadius: '4px',
  textTransform: 'none',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: isValid ? '#1976d2' : 'rgba(33, 150, 243, 0.3)',
  },
  '&.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.5)',
  }
}));

export const WarningText = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: '#f44336',
  fontSize: '0.75rem',
  marginTop: '4px',
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
  }
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: 'rgba(255, 255, 255, 0.7)',
  marginBottom: '8px',
  display: 'flex',
  alignItems: 'center',
}));

export const RequiredMark = styled('span')(({ theme }) => ({
  color: '#f44336',
  marginLeft: '4px',
}));

export const DividerWrapper = styled(Box)(({ theme }) => ({
  padding: '0 24px',
}));

export const CustomDivider = styled(Divider)(({ theme }) => ({
  borderColor: 'rgba(255, 255, 255, 0.1)',
}));